export const STORAGE_KEYS = Object.freeze({
  AUTH_TOKEN: 'auth_token',
  USER_ID: 'user_id',
  OAUTH_SUBS_USER_ID: 'jetogo_user_id_for_subs',
  LEGACY_OAUTH_SUBS_USER_ID: 'jetogo_uid_for_subs'
});

export const HEADER_KEYS = Object.freeze({
  USER_ID: 'x-user-id',
  USER_UUID: 'x-user-uuid',
  LEGACY_SUBS_USER_ID: 'x-user-id-for-subs'
});

const hasLocalStorage = () => (
  typeof window !== 'undefined' &&
  typeof window.localStorage !== 'undefined'
);

export const getStoredOAuthSubUserId = () => {
  if (!hasLocalStorage()) return '';
  return (
    localStorage.getItem(STORAGE_KEYS.OAUTH_SUBS_USER_ID) ||
    localStorage.getItem(STORAGE_KEYS.LEGACY_OAUTH_SUBS_USER_ID) ||
    ''
  );
};

export const setStoredOAuthSubUserId = (userId) => {
  if (!hasLocalStorage() || !userId) return;
  localStorage.setItem(STORAGE_KEYS.OAUTH_SUBS_USER_ID, userId);
  localStorage.removeItem(STORAGE_KEYS.LEGACY_OAUTH_SUBS_USER_ID);
};

export const clearStoredOAuthSubUserId = () => {
  if (!hasLocalStorage()) return;
  localStorage.removeItem(STORAGE_KEYS.OAUTH_SUBS_USER_ID);
  localStorage.removeItem(STORAGE_KEYS.LEGACY_OAUTH_SUBS_USER_ID);
};
